export const environment = {
  production: true,
  apiUrl: 'https://dev.cultura.tools/api',
  ui: 'https://dev.cultura.tools',
  termsUrl: 'https://dev.cultura.tools/terms', // Nutzungsbedingungen (Route /terms), leer = ohne Link
  privacyUrl: 'https://dev.cultura.tools/privacy', // Öffentliche Datenschutzerklärung (Route /privacy), leer = ohne Link
  wsUrl: 'wss://dev.cultura.tools',
  features: {
    aiChat: true,
    culturaReports: true,
    realtimeAnalysis: true,
    unlimitedQueries: true
  }
};